<template>
  <div class="content">
    <div class="content-top">
      <span :class="type == 1? 'active' : ''" @click="changeType(1)">进度预览</span>
      <span :class="type == 2? 'active' : ''" @click="changeType(2)">节点申报</span>
      <span :class="type == 3? 'active' : ''" @click="changeType(3)">节点进度</span>
    </div>
    <div class="content-box">
      <progress-view v-if="type == 1"></progress-view>
      <node-declara v-else-if="type == 2"></node-declara>
      <node-progress v-else-if="type == 3"></node-progress>
    </div>
  </div>
</template>

<script>
  import progressView from './components/progressView.vue'
  import nodeDeclara from './components/nodeDeclara.vue'
  import nodeProgress from './components/nodeProgress.vue'
  export default {
    components: {
      progressView,
      nodeDeclara,
      nodeProgress
      },
    data() {
      return {
        type: 1
      }
    },
    created() {
      
    },
    methods: {
      changeType(type){
        this.type = type
      }
    },
  }
</script>

<style scoped>
.content{
  padding: 1vh 1vw;
}
.content-top{
  height: 56px;
  border-radius: 6px;
  background-color: #fff;
  text-align: left;
  margin-bottom: 8px;
}
.content-top > span {
  margin-left: 18px;
  padding-bottom: 18px;
  line-height: 56px;
  cursor: pointer;
}
.content-box{
  height: calc(100% - 64px);
  overflow: auto;
}
.active{
  border-bottom: 2px solid #4D6EB1;
}
</style>